import { render, staticRenderFns } from "./tableBlockEditor.vue?vue&type=template&id=f7df61ce"
import script from "./tableBlockEditor.vue?vue&type=script&lang=js"
export * from "./tableBlockEditor.vue?vue&type=script&lang=js"
import style0 from "./tableBlockEditor.vue?vue&type=style&index=0&id=f7df61ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports